import { entity } from "simpler-state";
import { ISupplier, supplierState } from "../types/global.types";

export const defaultSupplierLogo =
  "https://pif-space.s3.eu-north-1.amazonaws.com/migrated-partners-images/000542.png";

const defaultState: supplierState = {
  selectedSupplier: null,
  inviteSupplierForm: {
    name: "",
    email: "",
    phone: "",
    logo: defaultSupplierLogo,
    phonePrefix: "45",
    headquarterAddress: "",
    headquarterCity: "",
    headquarterCountry: "",
    headquarterZipCode: "",
    marketplaces: [""],
    accountName: "",
    accountNumber: "",
    bankCountry: "",
    bankName: "",
    currency: "",
    redeemType: "mobile-redemption",
    status: "active",
    isPeriodically: true,
    startProportion: 50,
    periodType: "monthly",
    isAmountThreshold: false,
    enableRewardSystem: false,
    isCharity: false,
    enablePushNotification: false,
    finishProportion: 40,
    pifProportion: 10,
    fixedFee: 0,
  },
};
export const supplierEntity = entity<supplierState>(defaultState);

export const setSelectedSupplier = (supplier: ISupplier) => {
  supplierEntity.set((prevState) => ({
    ...prevState,
    selectedSupplier: supplier,
  }));
};

export const addSupplierInfo = (data: any) => {
  supplierEntity.set((prevState) => ({
    ...prevState,
    inviteSupplierForm: { ...prevState.inviteSupplierForm, ...data },
  }));
};
export const clearSupplierInfo = () => {
  supplierEntity.set((prevState) => ({
    ...prevState,
    inviteSupplierForm: defaultState.inviteSupplierForm,
  }));
};
